import axios from 'axios'

export const oauthCallback = async code => {
  try {
    const { data } = await axios.post(`${process.env.MIX_PASSPORT_URL}/oauth/token`, {
      grant_type: 'authorization_code',
      client_id: process.env.MIX_PASSPORT_ID,
      client_secret: process.env.MIX_PASSPORT_SECRET,
      redirect_uri: process.env.MIX_PASSPORT_CALLBACK_URL,
      code: code
    })

    return data
  } catch (_error) {
    return null
  }
}

export const oauthUser = async token => {
  try {
    const { data } = await axios.get(`${process.env.MIX_PASSPORT_URL}/api/v1/me`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })

    return data
  } catch (_error) {
    return null
  }
}

export const smsSignin = async token => {
  try {
    const { data } = await axios.post(`${process.env.MIX_URL}/sms-login/${token}`)

    return data
  } catch (error) {
    return {
      status_code: error.response?.status || 500,
      message: error.response?.data?.message || error.message
    }
  }
}
